import { render, staticRenderFns } from "./Pocetna.vue?vue&type=template&id=d7a55566&scoped=true&"
import script from "./Pocetna.vue?vue&type=script&lang=js&"
export * from "./Pocetna.vue?vue&type=script&lang=js&"
import style0 from "./Pocetna.vue?vue&type=style&index=0&id=d7a55566&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7a55566",
  null
  
)

export default component.exports